export default __webpack_public_path__ + "static/media/e.0980c165dcb3b47135371c8e226e36ed.mp3";